import { render, staticRenderFns } from "./measure-draggable.vue?vue&type=template&id=e83048e2&scoped=true&"
import script from "./measure-draggable.vue?vue&type=script&lang=js&"
export * from "./measure-draggable.vue?vue&type=script&lang=js&"
import style0 from "./measure-draggable.vue?vue&type=style&index=0&id=e83048e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e83048e2",
  null
  
)

export default component.exports